import React from "react";

import { cn } from "@shared/ui/utils";

import { AnimatedGroup } from "~/components/motion-primitives/animated-group";
import { SectionTitle } from "~/components/section-title";

interface SectionProps {
  id?: string;
  title: string;
  children: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
  contentClass?: string;
}
export const Section = ({ title, children, className, contentClass, description, id }: SectionProps) => {
  return (
    <section id={id} className={cn("mx-auto max-w-5xl px-4 py-16 md:my-10 md:py-10", className)}>
      <AnimatedGroup>
        <div className="mb-12 space-y-3">
          <SectionTitle title={title} />
          <p className="text-static-secondary text-md text-center md:text-left">{description} </p>
        </div>
        <div className={cn("grid grid-cols-1 gap-6 md:grid-cols-2", contentClass)}>{children}</div>
      </AnimatedGroup>
    </section>
  );
};
